// extracted by css-extract-rspack-plugin
export default {"item":"item__qGTfb","specialOffersPlacementContainer":"specialOffersPlacementContainer__i53h7","listRow":"listRow__D9weL"};